(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("import-studded-tire", {
            parent: "price",
            url: "/import-studded-tire",
            data: {
                authorities: ["bilioslo-admin"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/price/import-studded-tire/import-studded-tire.html",
                    controller: "ImportStuddedTireController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
